var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocial01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.5C15 3.35786 11.6421 0 7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.2434 2.74263 14.3462 6.32812 14.9089V9.66797H4.42383V7.5H6.32812V5.84766C6.32812 3.96797 7.44785 2.92969 9.16099 2.92969C9.9813 2.92969 10.8398 3.07617 10.8398 3.07617V4.92188H9.89414C8.9625 4.92188 8.67188 5.50005 8.67188 6.09375V7.5H10.752L10.4194 9.66797H8.67188V14.9089C12.2574 14.3462 15 11.2434 15 7.5Z",
    fill: "#333448"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial01);
export default __webpack_public_path__ + "static/media/social-01.adc43587539960777c3ee9e3c24f55bc.svg";
export { ForwardRef as ReactComponent };